import getUserPreferences from '@ynap/user-state/src/selectors/getUserPreferences'

export default function getMarketingPreferences(state) {
    const { countries, user, userPreferencesUpdating, modifyUserPreferencesSuccess, modifyUserPreferencesError } = state
    const userPrefs = getUserPreferences(state)

    // Designer preferences are managed in a different place
    const sizePreferences = (state.sizePreferences || [])
        .filter((prefSet) => prefSet.identifier !== 'DESIGNERS')
        .map((prefSet) => ({
            ...prefSet,
            values: prefSet.values.map((value) => ({
                id: value.identifier,
                selected: userPrefs[prefSet.identifier] && userPrefs[prefSet.identifier][value.identifier],
                label: value.value,
            })),
        }))

    const emailConsent = ((user && user.contextAttribute) || []).find((attr) => {
        const isConsentAttr = attr.attributeName === 'maMarketingEmailStandard'
        return isConsentAttr && attr.attributeValue.find((value) => value.value.find((v) => v === 'true'))
    })

    const preferredCountryAttr = ((user && user.contextAttribute) || []).find(
        (attr) => attr.attributeName === 'maPreferredCountry'
    )

    return {
        sizePreferences,
        emailConsent: !!emailConsent,
        isUpdating: userPreferencesUpdating,
        didSucceed: modifyUserPreferencesSuccess,
        didFail: modifyUserPreferencesError,
        preferredCountry: preferredCountryAttr?.attributeValue[0].value[0],
        ...(user?.preferredLanguage && { preferredLanguage: user.preferredLanguage }),
    }
}
